import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import constants from '@constants';
import { ExpandableContext } from '@components/contexts';
import PaymentsContext from '../../paymentsContext';

const SubMenu = (props) => {
	const {
		viewType,
		actionClicked,
		onExportCSV,
		listData,
		loadingData,
		officerOrAgency,
		user,
	} = props;

	const checks = listData.filter((item) => item.Checked);

	const {
		setOfficerOrAgency,
	} = useContext(PaymentsContext);

	return (
		<div className="search-bar">
			<div className="flex flex-align-items-center">
				<div className="flex-2">
					<Choose>
						{/* Temp disable agency invoices until fixed */}
						<When condition={viewType === constants.VIEW_INVOICE_STATUS.payment.viewType}>
							<div>
								<div className="btn-group">
									<Button
										bsStyle={officerOrAgency === 'officer' ? 'primary' : undefined}
										onClick={() => setOfficerOrAgency('officer')}
									>
										Officer
									</Button>
									<Button
										bsStyle={officerOrAgency === 'agency' ? 'primary' : undefined}
										onClick={() => setOfficerOrAgency('agency')}
									>
										Agency
									</Button>
								</div>
							</div>
						</When>

						<Otherwise>
							<h3 className="margin-0">
								{ constants.VIEW_INVOICE_STATUS[viewType].displayName }
							</h3>
						</Otherwise>
					</Choose>
				</div>
				<div className="flex-2 flex-align-items-center text-right">
					<If condition={viewType !== constants.VIEW_INVOICE_STATUS.dispute.viewType}>
						<Choose>
							<When condition={viewType !== 'balance' && viewType !== 'paid' && officerOrAgency === 'officer'}>
								<Button
									bsStyle="link"
									className="margin-right-20 color-gray-periwinkle"
									onClick={onExportCSV}
									disabled={loadingData}
								>
									<i className="rkf rkf-csv font-size-35" />
								</Button>
							</When>
							<When when condition={viewType === 'balance'}>
								<Link to="/account#payment">
									Change default card
								</Link>
							</When>
						</Choose>
						<If condition={(user.IsStaffAdmin && viewType === 'payment' && officerOrAgency === 'officer') || viewType === 'review'}>
							<Button
								bsStyle="primary"
								className="margin-right-10"
								onClick={actionClicked('selected')}
								disabled={checks.length < 1}
							>
								{ viewType === 'payment' ? 'Pay' : 'Approve' }
								{' '}
								Selected
							</Button>
							<Button
								bsStyle="primary"
								className="margin-right-10"
								onClick={actionClicked('bulk')}
								disabled={listData.length === 0}
							>
								{ viewType === 'payment' ? 'Pay' : 'Approve' }
								{' '}
								All
							</Button>
						</If>
					</If>
					<If condition={viewType !== 'balance' && viewType !== 'paid'}>
						<ExpandableContext.Consumer>
							{({ expanded, onToggle }) => (
								<Button
									title="Filters"
									onClick={onToggle}
									bsStyle={expanded ? 'primary' : undefined}
									className="btn-white-gray btn-stand-alone"
								>
									<i className="rkf rkf-filters margin-right-5" />
									Filters
								</Button>
							)}
						</ExpandableContext.Consumer>
					</If>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = ({
	app : { user },
	router : {
		location : { pathname },
	},
	payments : {
		data : { listData },
		loading : {
			listData : loadingData,
		},
		officerOrAgency,
	},
}) => ({
	user,
	listData,
	loadingData,
	officerOrAgency,
	viewType : pathname.split('/')[3] || 'payment',
});

SubMenu.propTypes = {
	actionClicked  	: PropTypes.func.isRequired,
	listData       	: PropTypes.array,
	loadingData    	: PropTypes.bool,
	officerOrAgency : PropTypes.string,
	onExportCSV     : PropTypes.func.isRequired,
	user            : PropTypes.object,
	viewType        : PropTypes.string,
};

SubMenu.defaultProps = {
	listData       	: [],
	loadingData    	: false,
	user           	: {},
	viewType       	: '',
	officerOrAgency : 'officer',
};

export default connect(mapStateToProps)(SubMenu);
